// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import single from './routes/single';
import templateStaticScroll from './routes/templateStaticScroll';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Template specify routes
  templateStaticScroll,
  single
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js